@if(data){
<a (click)="routeTo()" class="custom-snackbar">
    <div class="message">
        <app-icon [name]="data.icon" [colour]="data.colour" />
        <p><span [ngStyle]="{'color': data.colour}">{{data.learnerName}}</span>{{data.message}}</p>
    </div>
    <button mat-icon-button class="close-snackbar-btn" (click)="onClose($event)">
        <app-icon name="cross" />
    </button>
</a>
}